import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import WhyRetrofit from "./components/WhyRetrofit";
import PartnersStrip from "./components/PartnersStrip";
import CompanyHighlight from "./components/CompanyHighlight";
import SolutionsPreview from "./components/SolutionsPreview";
import ProcessSection from "./components/ProcessSection";
import TechnologySection from "./components/TechnologySection";
import BatterySection from "./components/BatterySection";
import ConnectedChargingSection from "./components/ConnectedChargingSection";
import FleetSection from "./components/FleetSection";
import SafetySection from "./components/SafetySection";
import ProjectsCtaSection from "./components/ProjectsCtaSection";
import EligibilitySection from "./components/EligibilitySection";

export default function Home() {
  return (
    <>
      <Seo
        title="KAL LORDS ZERO21 DJT | EV Retrofit Technology India"
        description="Transform your existing vehicle into electric. EV retrofit technology, ICE to EV conversion, battery systems, charging ecosystem and fleet electrification."
        keywords="EV retrofit, electric vehicle retrofit, ICE to EV conversion, vehicle electrification, fleet electrification"
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "KAL LORDS ZERO21 DJT",
          legalName: "KAL LORDS ZERO21 DJT TECHNOLOGIES PVT. LTD.",
          description:
            "EV retrofit technology collaboration converting suitable existing vehicles into electric vehicles.",
          url: "https://kallordszero21djt.com/",
          areaServed: "IN",
        }}
      />
      <Hero />
      <PartnersStrip />
      <WhyRetrofit />
      <CompanyHighlight />
      <SolutionsPreview />
      <ProcessSection />
      <TechnologySection />
      <BatterySection />
      <ConnectedChargingSection />
      <FleetSection />
      <SafetySection />
      <ProjectsCtaSection />
      <EligibilitySection />
    </>
  );
}